<template>
  <div class="create_wrapper fadeIn">
    <!-- Start Breadcrumb -->
    <Breadcrumb :items="items" />
    <!-- End Breadcrumb -->

    <div class="custom_card">
      <div class="card-header">
        <h4 class="card-title">{{ $t("addNew") }}</h4>
      </div>
      <!-- <UplodeMultiple></UplodeMultiple> -->
      <!-- ==== Start Form ==== -->
      <form @submit.prevent="validateCreateForm">
        <div class="container">
          <div class="row justify-content-between product">
            <div class="col-12">
              <div
                class="top_label row justify-content-start align-items-center"
              >
                <div class="">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    name="category"
                    id="project"
                    value="true"
                    v-model="ready_for_publish"
                  />
                  <label for="project">
                    نشر في الموقع
                  </label>
                </div>
              </div>
            </div>
            <div class="upload_input_wrapper me-auto col-6">
              <div class="col-8 mx-auto">
                <uplode-image
                  :data_src="data.image"
                  @inputChanged="uploadIndexImage"
                  placeHolder=" الصورة الاساسية الخارجية"
                ></uplode-image>
              </div>
            </div>
            <div class="upload_input_wrapper me-auto col-6">
              <div class="col-8 mx-auto">
                <uplode-image
                  :data_src="data.inner_image"
                  @inputChanged="uploadShowImage"
                  placeHolder="الصورة الاساسية الداخلية"
                ></uplode-image>
              </div>
            </div>
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="text"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  @keypress="isArabic"
                  v-model.trim="data.alt_image_ar"
                />
                <label for="name_input" class="form-label"
                  >النص البديل للصورة (عربي)</label
                >
              </div>
            </div>
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="text"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  @keypress="isEnglish"
                  v-model.trim="data.alt_image_en"
                />
                <label for="name_input" class="form-label"
                  >النص البديل للصورة (إنجليزي)</label
                >
              </div>
            </div>
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="text"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  @keypress="isArabic"
                  v-model.trim="data.title_ar"
                />
                <label for="name_input" class="form-label"
                  >العنوان (عربي)</label
                >
              </div>
            </div>
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="text"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  @keypress="isEnglish"
                  v-model.trim="data.title_en"
                />
                <label for="name_input" class="form-label"
                  >الاسم (إنجليزي)</label
                >
              </div>
            </div>
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="text"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  @keypress="isArabic"
                  v-model.trim="data.type_ar"
                />
                <label for="name_input" class="form-label">النوع (عربي)</label>
              </div>
            </div>
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="text"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  @keypress="isEnglish"
                  v-model.trim="data.type_en"
                />
                <label for="name_input" class="form-label"
                  >النوع (إنجليزي)</label
                >
              </div>
            </div>
            <div class="col-lg-6 py-0">
              <div class="input_wrapper">
                <app-text-editor1
                  name="desc_ar"
                  label="الوصف (عربي)"
                  v-model="data.description_ar"
                />
              </div>
            </div>
            <div class="col-lg-6 py-0">
              <div class="input_wrapper">
                <app-text-editor1
                  name="desc_en"
                  label="الوصف (إنجليزي)"
                  v-model="data.description_en"
                />
              </div>
            </div>

            <div class="col-lg-12 row">
              <v-expansion-panels class="col-10">
                <!-- ======= Start Project Main Section =======  -->
                <v-expansion-panel
                  v-for="(content, index) in data.blog_contents"
                  :key="index"
                >
                  <v-expansion-panel-header>
                    <h5>المحور رقم {{ index + 1 }}</h5>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <!-- uploadBlogContentImage -->
                    <div class="row justify-content-between flex-warp py-3">
                      <div class="upload_input_wrapper me-auto col-7">
                        <div class="col-8 mx-auto">
                          <uplode-image
                            :data_src="content.image"
                            @inputChanged="
                              uploadBlogContentImage($event, index)
                            "
                            placeHolder="الصورة "
                          ></uplode-image>
                        </div>
                      </div>
                      <div class="col-lg-6 py-0">
                        <div class="input_wrapper top_label">
                          <input
                            type="text"
                            class="form-control"
                            @input="helper_checkIfInputIsEmpty"
                            @keypress="isArabic"
                            v-model.trim="content.alt_image_ar"
                          />
                          <label for="name_input" class="form-label"
                            >النص البديل للصورة (عربي)</label
                          >
                        </div>
                      </div>
                      <div class="col-lg-6 py-0">
                        <div class="input_wrapper top_label">
                          <input
                            type="text"
                            class="form-control"
                            @input="helper_checkIfInputIsEmpty"
                            @keypress="isEnglish"
                            v-model.trim="content.alt_image_en"
                          />
                          <label for="name_input" class="form-label"
                            >النص البديل للصورة (إنجليزي)</label
                          >
                        </div>
                      </div>
                      <div class="col-lg-6 py-0">
                        <div class="input_wrapper top_label">
                          <input
                            type="text"
                            class="form-control"
                            @input="helper_checkIfInputIsEmpty"
                            @keypress="isArabic"
                            v-model.trim="content.title_ar"
                          />
                          <label for="name_input" class="form-label"
                            >العنوان (عربي)</label
                          >
                        </div>
                      </div>
                      <div class="col-lg-6 py-0">
                        <div class="input_wrapper top_label">
                          <input
                            type="text"
                            class="form-control"
                            @input="helper_checkIfInputIsEmpty"
                            @keypress="isEnglish"
                            v-model.trim="content.title_en"
                          />
                          <label for="name_input" class="form-label"
                            >العنوان (إنجليزي)</label
                          >
                        </div>
                      </div>
                      <div class="col-lg-6 py-0">
                        <div class="input_wrapper">
                          <app-text-editor1
                            name="description_ar"
                            label=" المحتوي (عربي)"
                            v-model="content.description_ar"
                          />
                        </div>
                      </div>
                      <div class="col-lg-6 py-0">
                        <div class="input_wrapper">
                          <app-text-editor1
                            name="description_en"
                            label=" المحتوي (إنجليزي)"
                            v-model="content.description_en"
                          />
                        </div>
                      </div>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
              <!-- Actions -->
              <div class="col-1 py-0" v-if="data.blog_contents.length > 0">
                <span class="append" @click="appendBlogContent()">
                  <i class="fas fa-plus-circle"></i>
                </span>
              </div>
              <div class="col-1 py-0" v-show="data.blog_contents.length > 1">
                <span class="append" @click="deleteBlogContent()">
                  <i class="fas fa-minus-circle"></i>
                </span>
              </div>
            </div>
            <div class="col-lg-6 py-0">
              <div class="input_wrapper">
                <label for="textarea_1" class="form-label"> Tags (عربي)</label>
                <vue-tags-input
                  max-width="100%"
                  v-model="tag_ar"
                  :tags="tags_ar"
                  @tags-changed="(newTags) => (tags_ar = newTags)"
                />
              </div>
            </div>
            <div class="col-lg-6 py-0">
              <div class="input_wrapper">
                <label for="textarea_1" class="form-label">
                  Tags (إنجليزي)</label
                >
                <vue-tags-input
                  max-width="100%"
                  v-model="tag_en"
                  :tags="tags_en"
                  @tags-changed="(newTags) => (tags_en = newTags)"
                />
              </div>
            </div>

            <div class="col-lg-6 py-0">
              <div class="input_wrapper">
                <label for="name_input" class="form-label">تاريخ النشر </label>
                <custom-date-picker
                  v-model="data.published_at"
                  type="datetime"
                ></custom-date-picker>
              </div>
            </div>
            <!-- End Add to website or No  -->
            <div class="buttons_wrapper">
              <button class="base-btn" :disabled="btnIsLoading">
                {{ $t("forms.submit") }}
                <span class="btn_loader" v-if="btnIsLoading"></span>
              </button>
            </div>
          </div>
        </div>
      </form>
      <!-- ==== End Form ==== -->
    </div>
  </div>
</template>

<script>
import VueTagsInput from "@johmun/vue-tags-input";

export default {
  components: {
    VueTagsInput,
  },
  name: "Update",
  props: ["id"],
  data() {
    return {
      tag_ar: "",
      tag_en: "",
      tags_ar: [],
      tags_en: [],
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.blogs.title"),
          disabled: false,
          href: "/blogs",
        },
        {
          text: this.$t("breadcrumb.blogs.edit"),
          disabled: true,
          href: "",
        },
      ],

      // ========== Loading
      btnIsLoading: false,
      ready_for_publish: false,
      // ========== create_data
      data: {
        image: null,
        title_ar: null,
        title_en: null,
        description_ar: null,
        description_en: null,
        type_key: null,
        type_ar: null,
        type_en: null,
        published_at: null,
        inner_image: null,
        alt_image_ar: null,
        alt_image_en: null,
        blog_contents: [
          {
            image: null,
            title_ar: null,
            title_en: null,
            description_ar: null,
            description_en: null,
            alt_image_ar: null,
            alt_image_en: null,
            is_intro: false,
          },
        ],
      },
    };
  },

  computed: {},

  methods: {
    uploadIndexImage(image) {
      this.data.image = image;
    },
    uploadShowImage(image) {
      this.data.inner_image = image;
    },
    uploadBlogContentImage(image, index) {
      this.data.blog_contents[index].image = image;
    },
    appendBlogContent() {
      this.data.blog_contents.push({
        image: null,
        title_ar: null,
        title_en: null,
        description_ar: null,
        description_en: null,
        alt_image_ar: null,
        alt_image_en: null,
        // is_intro:false,
      });
    },
    deleteBlogContent() {
      let lastElement = this.data.blog_contents[
        this.data.blog_contents.length - 1
      ];
      if (lastElement.id) {
        this.axios({
          method: "DELETE",
          url: `blog_content/${lastElement.id}`,
        })
          .then(() => {
            this.$iziToast.success({
              timeout: 2000,
              message: this.$t("deleteSuccess"),
              position: "bottomRight",
            });
            this.data.blog_contents.splice(-1);
          })
          .catch((err) => {
            // this.dialogDelete = false
            this.$iziToast.error({
              timeout: 2000,
              message: err.response.data.message,
              position: "bottomRight",
            });
          });
      } else {
        this.data.blog_contents.splice(-1);
      }
    },

    // Validate Data
    validateCreateForm() {
      let validate = false;
      this.btnIsLoading = true;
      if (!this.data.image) {
        this.$iziToast.error({
          timeout: 2000,
          message: "  صورة المقال الاساسية  (الخارجية) مطلوبة",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.inner_image) {
        this.$iziToast.error({
          timeout: 2000,
          message: "  صورة المقال الاساسية (الداخلية) مطلوبة",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.title_ar) {
        this.$iziToast.error({
          timeout: 2000,
          message: "  عنوان المقال  مطلوب (عربي ) ",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.title_en) {
        this.$iziToast.error({
          timeout: 2000,
          message: "  عنوان المقال  مطلوب (أنجليزي ) ",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.type_ar) {
        this.$iziToast.error({
          timeout: 2000,
          message: "  النوع  مطلوبة (عربي ) ",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.type_en) {
        this.$iziToast.error({
          timeout: 2000,
          message: "  النوع  مطلوبة (أنجليزي ) ",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.description_ar) {
        this.$iziToast.error({
          timeout: 2000,
          message: "  الوصف   مطلوبة (عربي ) ",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.description_en) {
        this.$iziToast.error({
          timeout: 2000,
          message: "   الوصف  مطلوبة (أنجليزي ) ",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else {
        // if (validate) return;
        this.data.blog_contents.map((section, index) => {
          if (validate) return;
          if (!section.image) {
            this.$iziToast.error({
              timeout: 2000,
              message: `أدخل الصورة في المحور رقم    ${index + 1}  `,
              position: "bottomRight",
            });
            validate = true;
            this.btnIsLoading = false;
            return;
          } else if (!section.title_ar) {
            this.$iziToast.error({
              timeout: 2000,
              message: ` عنوان المحور رقم ${index + 1}  مطلوب (عربي)`,
              position: "bottomRight",
            });
            validate = true;
            this.btnIsLoading = false;
            return;
          } else if (!section.title_en) {
            this.$iziToast.error({
              timeout: 2000,
              message: ` عنوان المحور رقم ${index + 1}  مطلوب (أنجليزي)`,
              position: "bottomRight",
            });
            validate = true;
            this.btnIsLoading = false;
            return;
          } else if (!section.description_ar) {
            this.$iziToast.error({
              timeout: 2000,
              message: ` المحتوي في المحور رقم ${index + 1}  مطلوب (عربي)`,
              position: "bottomRight",
            });
            validate = true;
            this.btnIsLoading = false;
            return;
          } else if (!section.description_en) {
            this.$iziToast.error({
              timeout: 2000,
              message: ` المحتوي في المحور رقم ${index + 1}  مطلوب (أنجليزي)`,
              position: "bottomRight",
            });
            validate = true;
            this.btnIsLoading = false;
            return;
          }
        });
      }
      this.submitData();
      return;
    },

    // Submit Data
    submitData() {
      this.btnIsLoading = true;
      const submit_data = new FormData();
      if (this.data.image.img_file) {
        submit_data.append("image", this.data.image.img_file);
      }
      if (this.data.inner_image.img_file) {
        submit_data.append("inner_image", this.data.inner_image.img_file);
      }
      submit_data.append("type_key", this.data.type_en);
      submit_data.append("ready_for_publish", +this.ready_for_publish);

      submit_data.append("published_at", this.data.published_at);
      submit_data.append("ar[type]", this.data.type_ar);
      submit_data.append("en[type]", this.data.type_en);

      submit_data.append("ar[title]", this.data.title_ar);
      submit_data.append("en[title]", this.data.title_en);

      submit_data.append(`ar[description]`, this.data.description_ar);
      submit_data.append(`en[description]`, this.data.description_en);

      submit_data.append(`ar[alt_image]`, this.data.alt_image_ar ?? "");

      submit_data.append(`en[alt_image]`, this.data.alt_image_en ?? "");

      this.tags_ar.map((item, index) => {
        submit_data.append(`tags[${index}][ar][title]`, item.text);
      });
      this.tags_en.map((item, index) => {
        submit_data.append(`tags[${index}][en][title]`, item.text);
      });
      this.data.blog_contents.map((item, index) => {
        // console.log("item =>",item)
        if (item.image.img_file) {
          submit_data.append(
            `blog_contents[${index}][image]`,
            item.image.img_file
          );
        }
        if (item.id) {
          submit_data.append(`blog_contents[${index}][id]`, item.id);
        }
        submit_data.append(`blog_contents[${index}][order]`, index + 1);
        // submit_data.append(`blog_contents[${index}][order]`, index + 1)
        // if(index==0){
        //   submit_data.append(`blog_contents[${index}][is_intro]`, 1)
        // }
        // submit_data.append(`blog_contents[${index}][is_intro]`, +item.is_intro)

        submit_data.append(
          `blog_contents[${index}][ar][alt_image]`,
          item.alt_image_ar ?? ""
        );

        submit_data.append(
          `blog_contents[${index}][en][alt_image]`,
          item.alt_image_en ?? ""
        );

        submit_data.append(`blog_contents[${index}][ar][title]`, item.title_ar);
        submit_data.append(`blog_contents[${index}][en][title]`, item.title_en);
        submit_data.append(
          `blog_contents[${index}][ar][description]`,
          item.description_ar
        );
        submit_data.append(
          `blog_contents[${index}][en][description]`,
          item.description_en
        );
      });
      submit_data.append(`_method`, "PUT");
      this.axios({
        method: "POST",
        url: `blog/${this.id}`,
        data: submit_data,
      })
        .then(() => {
          this.btnIsLoading = false;
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("editSuccess"),
            position: "bottomRight",
          });
          this.$router.push({ path: "/blogs" });
        })
        .catch((err) => {
          this.btnIsLoading = false;
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
        });
    },

    // Get Data
    getData() {
      this.loadingPage = true;
      this.axios({
        method: "GET",
        url: `blog/${this.id}`,
      })
        .then((res) => {
          this.model = res.data.data.design;
          this.data = res.data.data;
          console.log(this.data);
          if (res.data.data.published_at) {
            this.ready_for_publish = true;
          }
          this.tags_en = res.data.data.tags.map((item) => {
            return {
              text: item.title_en,
            };
          });
          this.tags_ar = res.data.data.tags.map((item) => {
            return {
              text: item.title_ar,
            };
          });
          this.loadingPage = false;
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
          this.$router.push({ path: "/blogs" });
          this.loadingPage = false;
        });
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
.product {
  .chooseImage {
    width: auto !important;
  }
}

.productDetails {
  border: 1px solid #339989;
  border-radius: 15px;
  padding-block: 20px;

  &.disabled {
    cursor: not-allowed;

    h3 {
      color: gray;
      font-size: 25px;
    }

    h4 {
      font-size: 21px;
      color: gray;
    }

    & > * {
      pointer-events: none;
    }
  }
}
</style>
<style lang="scss">
.ti-input {
  border: 0px !important;
}
.vue-tags-input {
  max-width: unset !important;
  width: 100% !important;
}
</style>
